import { render, staticRenderFns } from "./stakeVote.vue?vue&type=template&id=71e275d3&"
import script from "./stakeVote.vue?vue&type=script&lang=js&"
export * from "./stakeVote.vue?vue&type=script&lang=js&"
import style0 from "./stakeVote.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports